import React from 'react'

const PageTitle = () => (
  <h3 className="page-title col-md-10">
    <small>You can view admin-created users and create new users from the admin-panel.<br />
    The users will still be viewed here until it agreed the Terms and Conditions.</small>
  </h3>
)

export default PageTitle
